/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as SigninRouteImport } from "./routes/signin"
import { Route as AppIndexRouteImport } from "./routes/_app/index"
import { Route as AppAuditRouteImport } from "./routes/_app/audit"
import { Route as AppCompaniesRouteImport } from "./routes/_app/companies"
import { Route as AppCostsRouteImport } from "./routes/_app/costs"
import { Route as AppDemoRequestsRouteImport } from "./routes/_app/demo-requests"
import { Route as AppLogsRouteImport } from "./routes/_app/logs"
import { Route as AppParallelDialingRouteImport } from "./routes/_app/parallel-dialing"
import { Route as AppReadinessRouteImport } from "./routes/_app/readiness"
import { Route as AppReleasesRouteImport } from "./routes/_app/releases"
import { Route as AppResumeRouteImport } from "./routes/_app/resume"
import { Route as AppServerRouteImport } from "./routes/_app/server"
import { Route as AppStaffRouteImport } from "./routes/_app/staff"
import { Route as AppReportsIndexRouteImport } from "./routes/_app/reports/index"
import { Route as AppReportsCompanyIdReportIdRouteImport } from "./routes/_app/reports/$companyId/$reportId"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: "/signin",
  path: "/signin",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesRoute = AppCompaniesRouteImport.update({
  id: "/companies",
  path: "/companies",
  getParentRoute: () => AppRoute,
} as any)
const AppCostsRoute = AppCostsRouteImport.update({
  id: "/costs",
  path: "/costs",
  getParentRoute: () => AppRoute,
} as any)
const AppDemoRequestsRoute = AppDemoRequestsRouteImport.update({
  id: "/demo-requests",
  path: "/demo-requests",
  getParentRoute: () => AppRoute,
} as any)
const AppLogsRoute = AppLogsRouteImport.update({
  id: "/logs",
  path: "/logs",
  getParentRoute: () => AppRoute,
} as any)
const AppParallelDialingRoute = AppParallelDialingRouteImport.update({
  id: "/parallel-dialing",
  path: "/parallel-dialing",
  getParentRoute: () => AppRoute,
} as any)
const AppReadinessRoute = AppReadinessRouteImport.update({
  id: "/readiness",
  path: "/readiness",
  getParentRoute: () => AppRoute,
} as any)
const AppReleasesRoute = AppReleasesRouteImport.update({
  id: "/releases",
  path: "/releases",
  getParentRoute: () => AppRoute,
} as any)
const AppResumeRoute = AppResumeRouteImport.update({
  id: "/resume",
  path: "/resume",
  getParentRoute: () => AppRoute,
} as any)
const AppServerRoute = AppServerRouteImport.update({
  id: "/server",
  path: "/server",
  getParentRoute: () => AppRoute,
} as any)
const AppStaffRoute = AppStaffRouteImport.update({
  id: "/staff",
  path: "/staff",
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: "/reports/",
  path: "/reports/",
  getParentRoute: () => AppRoute,
} as any)
const AppReportsCompanyIdReportIdRoute =
  AppReportsCompanyIdReportIdRouteImport.update({
    id: "/reports/$companyId/$reportId",
    path: "/reports/$companyId/$reportId",
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute
  "/signin": typeof SigninRoute
  "/audit": typeof AppAuditRoute
  "/companies": typeof AppCompaniesRoute
  "/costs": typeof AppCostsRoute
  "/demo-requests": typeof AppDemoRequestsRoute
  "/logs": typeof AppLogsRoute
  "/parallel-dialing": typeof AppParallelDialingRoute
  "/readiness": typeof AppReadinessRoute
  "/releases": typeof AppReleasesRoute
  "/resume": typeof AppResumeRoute
  "/server": typeof AppServerRoute
  "/staff": typeof AppStaffRoute
  "/reports/": typeof AppReportsIndexRoute
  "/reports/$companyId/$reportId": typeof AppReportsCompanyIdReportIdRoute
}
export interface FileRoutesByTo {
  "/signin": typeof SigninRoute
  "/audit": typeof AppAuditRoute
  "/companies": typeof AppCompaniesRoute
  "/costs": typeof AppCostsRoute
  "/demo-requests": typeof AppDemoRequestsRoute
  "/logs": typeof AppLogsRoute
  "/parallel-dialing": typeof AppParallelDialingRoute
  "/readiness": typeof AppReadinessRoute
  "/releases": typeof AppReleasesRoute
  "/resume": typeof AppResumeRoute
  "/server": typeof AppServerRoute
  "/staff": typeof AppStaffRoute
  "/": typeof AppIndexRoute
  "/reports": typeof AppReportsIndexRoute
  "/reports/$companyId/$reportId": typeof AppReportsCompanyIdReportIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/signin": typeof SigninRoute
  "/_app/audit": typeof AppAuditRoute
  "/_app/companies": typeof AppCompaniesRoute
  "/_app/costs": typeof AppCostsRoute
  "/_app/demo-requests": typeof AppDemoRequestsRoute
  "/_app/logs": typeof AppLogsRoute
  "/_app/parallel-dialing": typeof AppParallelDialingRoute
  "/_app/readiness": typeof AppReadinessRoute
  "/_app/releases": typeof AppReleasesRoute
  "/_app/resume": typeof AppResumeRoute
  "/_app/server": typeof AppServerRoute
  "/_app/staff": typeof AppStaffRoute
  "/_app/": typeof AppIndexRoute
  "/_app/reports/": typeof AppReportsIndexRoute
  "/_app/reports/$companyId/$reportId": typeof AppReportsCompanyIdReportIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/signin"
    | "/audit"
    | "/companies"
    | "/costs"
    | "/demo-requests"
    | "/logs"
    | "/parallel-dialing"
    | "/readiness"
    | "/releases"
    | "/resume"
    | "/server"
    | "/staff"
    | "/reports/"
    | "/reports/$companyId/$reportId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/signin"
    | "/audit"
    | "/companies"
    | "/costs"
    | "/demo-requests"
    | "/logs"
    | "/parallel-dialing"
    | "/readiness"
    | "/releases"
    | "/resume"
    | "/server"
    | "/staff"
    | "/"
    | "/reports"
    | "/reports/$companyId/$reportId"
  id:
    | "__root__"
    | "/_app"
    | "/signin"
    | "/_app/audit"
    | "/_app/companies"
    | "/_app/costs"
    | "/_app/demo-requests"
    | "/_app/logs"
    | "/_app/parallel-dialing"
    | "/_app/readiness"
    | "/_app/releases"
    | "/_app/resume"
    | "/_app/server"
    | "/_app/staff"
    | "/_app/"
    | "/_app/reports/"
    | "/_app/reports/$companyId/$reportId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SigninRoute: typeof SigninRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/signin": {
      id: "/signin"
      path: "/signin"
      fullPath: "/signin"
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/audit": {
      id: "/_app/audit"
      path: "/audit"
      fullPath: "/audit"
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/companies": {
      id: "/_app/companies"
      path: "/companies"
      fullPath: "/companies"
      preLoaderRoute: typeof AppCompaniesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/costs": {
      id: "/_app/costs"
      path: "/costs"
      fullPath: "/costs"
      preLoaderRoute: typeof AppCostsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/demo-requests": {
      id: "/_app/demo-requests"
      path: "/demo-requests"
      fullPath: "/demo-requests"
      preLoaderRoute: typeof AppDemoRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/logs": {
      id: "/_app/logs"
      path: "/logs"
      fullPath: "/logs"
      preLoaderRoute: typeof AppLogsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/parallel-dialing": {
      id: "/_app/parallel-dialing"
      path: "/parallel-dialing"
      fullPath: "/parallel-dialing"
      preLoaderRoute: typeof AppParallelDialingRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/readiness": {
      id: "/_app/readiness"
      path: "/readiness"
      fullPath: "/readiness"
      preLoaderRoute: typeof AppReadinessRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/releases": {
      id: "/_app/releases"
      path: "/releases"
      fullPath: "/releases"
      preLoaderRoute: typeof AppReleasesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/resume": {
      id: "/_app/resume"
      path: "/resume"
      fullPath: "/resume"
      preLoaderRoute: typeof AppResumeRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/server": {
      id: "/_app/server"
      path: "/server"
      fullPath: "/server"
      preLoaderRoute: typeof AppServerRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/staff": {
      id: "/_app/staff"
      path: "/staff"
      fullPath: "/staff"
      preLoaderRoute: typeof AppStaffRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/reports/": {
      id: "/_app/reports/"
      path: "/reports"
      fullPath: "/reports/"
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/reports/$companyId/$reportId": {
      id: "/_app/reports/$companyId/$reportId"
      path: "/reports/$companyId/$reportId"
      fullPath: "/reports/$companyId/$reportId"
      preLoaderRoute: typeof AppReportsCompanyIdReportIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAuditRoute: typeof AppAuditRoute
  AppCompaniesRoute: typeof AppCompaniesRoute
  AppCostsRoute: typeof AppCostsRoute
  AppDemoRequestsRoute: typeof AppDemoRequestsRoute
  AppLogsRoute: typeof AppLogsRoute
  AppParallelDialingRoute: typeof AppParallelDialingRoute
  AppReadinessRoute: typeof AppReadinessRoute
  AppReleasesRoute: typeof AppReleasesRoute
  AppResumeRoute: typeof AppResumeRoute
  AppServerRoute: typeof AppServerRoute
  AppStaffRoute: typeof AppStaffRoute
  AppIndexRoute: typeof AppIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppReportsCompanyIdReportIdRoute: typeof AppReportsCompanyIdReportIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAuditRoute: AppAuditRoute,
  AppCompaniesRoute: AppCompaniesRoute,
  AppCostsRoute: AppCostsRoute,
  AppDemoRequestsRoute: AppDemoRequestsRoute,
  AppLogsRoute: AppLogsRoute,
  AppParallelDialingRoute: AppParallelDialingRoute,
  AppReadinessRoute: AppReadinessRoute,
  AppReleasesRoute: AppReleasesRoute,
  AppResumeRoute: AppResumeRoute,
  AppServerRoute: AppServerRoute,
  AppStaffRoute: AppStaffRoute,
  AppIndexRoute: AppIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppReportsCompanyIdReportIdRoute: AppReportsCompanyIdReportIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SigninRoute: SigninRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
